const ceqThemeVariables = {
    footer__navIcon: 'arrow',
    footer__sectionPartPrefix: true,
    gapMatchExtended__supportsSplitScrolling: true,
    header__hidePreloadCaption: true,
    header__logoPath: 'images/logo/ceq.png',
    header__showSkipLink: false,
    options__fileDeliveryIcon: 'fa-floppy-o',
    options__moveFileDeliveryToInvigilator: true,
    question__displayTokensVertically: true,
    question__wideAndLeftAlign: true,
    rubric__showDynamicRubric: true,
    rubric__showQuestionRubric: true,
    rubric__showSectionRubric: false,
    scorableItemsDash: '–',
    stimulus__showMargins: false,
};

export default ceqThemeVariables;
